<template>
  <div>
    <!-- 工作量概况 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center m-b-20">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">工作量概况</span>
      </div>
      <div style="background: #DCEEFE;" class="b-r-4 m-b-24 p-24 text-center">
        <div class="font-28 cor-66"> 预估处理凭证数量</div>
        <div class=" cor-66 m-t-24 m-b-20 font-20"> <span class="font-32 cor-33 font-weight-bold m-r-4">{{   boardData.ticketNum}}</span>张</div>
        <div class="font-24 cor-66 ">注:根据系统中审核通过的审批流程进行预估，仅供参考</div>
      </div>
      <div id="gzlPie" ref="gzlPie" style="width: 90vw; height: 280px;"></div>
    </div>

    <!-- 付款详情 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center p-b-16">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">付款详情</span>
      </div>
      <div class="flex row-between p-b-20">
        <div class="width-49 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24">
          <div class="w-72 h-72 m-r-16">
            <img alt="付款申请" class="width-100 height-100" src="@/assets/icon/employeeKanban/caiwu/fksq.png">
          </div>
          <div>
            <div>
              <span class="font-40 font-weight-700">{{ boardData?.paymentAll }}</span>
              <span class="font-20"> 笔</span>
            </div>
            <div class="font-24">付款申请</div>
          </div>
        </div>
        <div class="width-49 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24">
          <div class="w-72 h-72 m-r-16">
            <img alt="实际付款" class="width-100 height-100" src="@/assets/icon/employeeKanban/caiwu/sjfk.png">
          </div>
          <div>
            <div>
              <span class="font-40 font-weight-700">{{ boardData?.paymentActual }}</span>
              <span class="font-20"> 笔</span>
            </div>
            <div class="font-24">实际付款</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 开票详情 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center p-b-16">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">开票详情</span>
      </div>
      <div class="flex row-between p-b-20">
        <div class="width-49 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24">
          <div class="w-72 h-72 m-r-16">
            <img alt="开票审批" class="width-100 height-100" src="@/assets/icon/employeeKanban/caiwu/kpsp.png">
          </div>
          <div>
            <div>
              <span class="font-40 font-weight-700">{{ boardData?.invoiceAll }}</span><span class="font-20"> 笔</span>
            </div>
            <div class="font-24">开票审批</div>
          </div>
        </div>
        <div class="width-49 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24">
          <div class="w-72 h-72 m-r-16">
            <img alt="开票数量" class="width-100 height-100" src="@/assets/icon/employeeKanban/caiwu/kpsl.png">
          </div>
          <div>
            <div>
              <span class="font-40 font-weight-700">{{ boardData?.invoiceActual }}</span><span class="font-20"> 张</span>
            </div>
            <div class="font-24">开票数量</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 报销详情 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center p-b-16">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">报销详情</span>
      </div>
      <div class="flex row-between">
        <div class="width-49 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24">
          <div class="w-72 h-72 m-r-16">
            <img alt="报销总笔数" class="width-100 height-100" src="@/assets/icon/employeeKanban/caiwu/bxzbs.png">
          </div>
          <div>
            <div>
              <span class="font-40 font-weight-700">{{ boardData?.expenseAll }}</span>
              <span class="font-20"> 笔</span>
            </div>
            <div class="font-24">报销总笔数</div>
          </div>
        </div>
        <div class="width-49 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24">
          <div class="w-72 h-72 m-r-16">
            <img alt="发票数量" class="width-100 height-100" src="@/assets/icon/employeeKanban/caiwu/fpsl.png">
          </div>
          <div>
            <div>
              <span class="font-40 font-weight-700">{{ boardData?.invoiceOrder }}</span>
              <span class="font-20"> 张</span>
            </div>
            <div class="font-24">发票数量</div>
          </div>
        </div>
      </div>

      <div class="p-16">
        <div v-for="(item, index) in boardData?.expenseMaps" :key="index" class="flex col-center row-between p-t-18 p-b-18 p-l-10 p-r-10" style="border-bottom: 1px solid #d4d5de;">
          <div class="flex col-center">
            <img alt="rank" class="w-34 h-34 m-r-16" src="@/assets/icon/employeeKanban/tablelogo.png" />
            <span class="font-28">{{ item.name }}</span>
          </div>
          <div class=" flex col-center font-28">{{ item.value }} {{ item.unit }}</div>
        </div>
      </div>
    </div>

    <!--其他事项-->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center p-b-16">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">其他事项</span>
      </div>
      <div class="flex flex-wrap">
        <div v-for="(item, index) in boardData?.others" :key="index" class="m-12 p-t-16 p-b-16 bg-F5F9FF b-r-8 text-center width-46">
          <div class="font-40 font-weight-700 m-b-10">{{ item.cnt }}<span class="font-20"> 次</span></div>
          <div class="font-24">{{ item.label }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import TitleLogo from "@/components/TitleLogo.vue";
import * as echarts from "echarts";
import echartMixin from "@/mixin/echartMixin";

export default {
  components: {TitleLogo},
  mixins: [echartMixin],
  props: {
    boardData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      gzlPie: null,
    }
  },
  watch: {
    boardData: {
      handler(newVal) {
        if (newVal.worksMaps) {
          this.initgzlPie(newVal.worksMaps)
        }
      },
      immediate: true // 立即执行一次，确保初始数据也能触发
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    initgzlPie(seriesData) {
      const gzlPieDom = this.$refs.gzlPie
      if (gzlPieDom) {
        echarts.dispose(gzlPieDom);
        this.gzlPie = echarts.init(gzlPieDom);
        const option = {
          tooltip: {
            trigger: 'item',
            formatter: '{b}<br/> {d}%',
            confine: true
          },
          legend: {
            bottom: '0',
            icon: 'circle',
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: [25, 90],
              center: ['50%', '41%'],
              // roseType: 'radius',
              // roseType: 'area',
              label: {
                show: true,
                position: 'outside',
                formatter: function (params) {
                  const name = params.name
                  const percent = params.percent + '%'
                  return `${percent}`
                },
              },
              labelLine: {
                lineStyle: {
                  color: '#999999'
                },
                smooth: 0.2,
                length: 15,
                length2: 8
              },
              itemStyle: {
                borderRadius: 8,
                borderWidth: 4,
                borderColor: '#ffffff',
              },
              data: seriesData
            }
          ]
        };
        this.gzlPie.setOption(option);

        window.addEventListener('resize', () => {
          this.gzlPie.resize();
        });
      }
    },
  }
}
</script>
<style lang="less" scoped>
</style>
